<template>
<div class="ui segments">

  <div class="ui segment">
    <div class="ui breadcrumb">
      <router-link :to="{name:'home'}" class="section">Sākums</router-link>
      <span class="divider">/</span>
      <router-link :to="{name:'user-address'}" class="section">Piegādes adrese</router-link>
      <span class="divider">/</span>
      <div class="active section">Rediģēt adresi</div>
    </div>
  </div>

  <div class="ui segment" v-bind:class="{ loading: showLoading }">

  <div class="ui warning icon message" v-if="legalAddressError">
    <i class="warning circle icon"></i>
    <div class="content">
    <div class="header">
      Pirms dzēsiet šo adresi, sākumā izvēlieties citu juridisko adresi!
    </div>
  </div>
  </div>

      <form class="ui form">
        <h3 class="ui dividing header">Rediģēt adresi</h3>




        <div class="ui negative icon message" v-if="error">
          <i class="warning circle icon"></i>
          <div class="content">
          <div class="header">
            Lūdzu aizpildi visus laukus:
          </div>
          <ul class="list">
            <li v-for="item in error">{{item[0]}}</li>
          </ul>
        </div>
        </div>
          <div class="ui hidden divider"></div>
          <div class="field" >
            <div class="ui checkbox">
              <input type="checkbox" :disabled="address.is_legal_address==1" v-model="addressItem.is_legal_address" value="1" number>
              <label for="newsletter">Juridiskā adrese</label>
            </div>
          </div>
         <div class="two fields">
           <div class="field">
             <label>Pilsēta</label>
             <select class="ui fluid dropdown" disabled v-model="address.city">
               <option value="">&nbsp;</option>
               <option v-for="item in city" v-bind:value="item.id">{{item.label}}</option>
             </select>
           </div>
           <div class="field">
             <label>Reģions</label>
             <select class="ui fluid dropdown"  disabled v-model="address.region">
               <option value="">&nbsp;</option>
               <option v-for="item in filteredRegion" v-bind:value="item.id">{{item.label}}</option>
             </select>
           </div>
         </div>
         <div class="field">
           <div class="three fields">
             <div class="field">
               <label>Iela</label>
               <input type="text"  placeholder="Iela" disabled v-model="address.street">
             </div>
             <div class="field">
               <label>Mājas nr. / nosaukums</label>
               <input type="text"  placeholder="Mājas nr. / nosaukums" v-model="address.house_no" disabled>
             </div>
             <div class="field">
               <label>Dzīvokļa nr.</label>
               <input type="text"  placeholder="Dzīvokļa nr." v-model="address.flat_no" disabled>
             </div>
           </div>
         </div>
         <div class="field">
           <div class="two fields">
             <div class="field">
               <label>Tālrunis kurjeram</label>
               <input type="text"  placeholder="Norādiet tālruni kurjeram" v-model="addressItem.phone" >
             </div>
             <div class="field">
               <label>Piezīmes</label>
               <input type="text"  placeholder="Piemēram, durvju kods" v-model="addressItem.notes">
             </div>
           </div>
         </div>


        <button v-on:click="initDeleteAddress(address)" class="ui right floated grey icon button">
        <i class="right trash icon"></i>
      </button>


              <div class="ui right floated buttons" style="margin-right:20px">
              <button class="ui button" @click="$router.push({name:'user-address'})">Atpakaļ</button>
              <div class="or" data-text="vai"></div>
              <button class="ui custom_brown button" @click="saveAddress">Saglabāt</button>

              </div>
        <div class="ui clearing hidden divider"></div>
      </form>
  </div>

  <!-- delete prompt -->
  <div id="user-address-details-delete-dialog" class="ui basic modal">
    <div class="ui icon header">
      <i class="trash icon"></i>
      Vai dzēst ierakstu?
    </div>

    <div class="actions">
      <div class="ui grey basic cancel inverted button">
        <i class="remove icon"></i>
        Nē
      </div>
      <div class="ui custom_brown ok inverted button" @click="deleteAddress">
        <i class="checkmark icon"></i>
        Jā
      </div>
    </div>
  </div>

</div>
</template>

<script>
export default {
  data () {
    return {
      addressItem:{
          is_legal_address: 0,
          city: 0,
          region:0,
          street:'',
          house_no:'',
          flat_no:'',
          phone:'',
          notes:'',
          id:0
      },
      showLoading:false,
      itemForDelete:false,
      legalAddressError: false

    }

  },
  computed: {
    error() {
      return this.$store.state.addressStore.status.error
    },
    user() {
      return this.$store.state.userStore.user
    },
    storeStatus() {
      return this.$store.state.userStore.status
    },
    city() {
      return this.$store.state.addressStore.city
    },
    region() {
      return this.$store.state.addressStore.region
    },
    address() {
      return this.$store.state.addressStore.item
    },

    filteredRegion(){
      var self = this
      return self.$store.state.addressStore.region.filter(function(e) { return e.city_id == self.address.city});
    },
  },

  activated: function() {

    this.legalAddressError = false;
    //reset form
    Object.assign(this.$data, this.$options.data());
    //clear errors
    this.$store.commit('SET_ERROR', ''); //this will reet all errors

    //preload data
    this.$store.dispatch('loadUser');
    var id = (this.$route.params.id) ? this.$route.params.id : 0;

    //first load dropdowns then set value
    this.$store.dispatch('loadCity').then((response) => {
        this.$store.dispatch('loadRegion').then((response) => {
            this.loadAddress(id)
        });
    });

  },

  methods: {

    loadAddress(id){
      this.showLoading = true;
      this.$store.dispatch('loadAddressItem', id).then((response) => {
          this.addressItem.notes = response.data.data.notes;
          this.addressItem.phone = response.data.data.phone;
          this.addressItem.id = response.data.data.id;
          this.addressItem.is_legal_address = response.data.data.is_legal_address

          this.showLoading = false;

      }).catch((error) => {
        //on error go back
        this.showLoading = false;
        this.$router.push({
            name: 'user-address'
        });
      });
    },

    saveAddress: function() {
      this.showLoading = true;
      this.legalAddressError = false;


      this.$store.dispatch('updateAddress', this.addressItem).then((response) => {
            this.$router.push({
                name: 'user-address'
            });

      }).catch((error) => {
        this.showLoading = false;
          console.error('Address was not saved')
      });

    },

    initDeleteAddress(item){

    //check if address is legal and if yes ask to set another legal address
    if(item.is_legal_address == 1) {
      this.legalAddressError = true


    }
    else {
        this.legalAddressError = false;


        this.itemForDelete = item
        $('#user-address-details-delete-dialog')
          .modal('show');
        }
    },

    deleteAddress: function() {
      this.$store.dispatch('deleteAddress', this.itemForDelete).then((response) => {
            this.$router.push({
                name: 'user-address'
            });

      }).catch((error) => {

          console.error('Address was not saved')
      });;
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserAddressEditPage.vue?125322db